<template>
  <card>
    <vue-element-loading :text="loading.text" spinner="bar-fade-scale" :color="loading.color" :active="loading.active"
      :is-full-screen="false" />
    <div slot="header">
      <h4 class="title">Nueva Licencia</h4>
    </div>
    <div>
      <form id="edit_form" @submit.prevent="validate">
        <!-- Campos básicos -->
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text" label="Compañia" placeholder="Solution Technology" v-model="device.company"
              name="company" :error="getError('company')" :disabled="true" />
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Contacto" placeholder="Nombre contacto" v-model="device.usuario"
              v-validate="modelValidations.usuario" name="usuario" :error="getError('usuario')" />
          </div>
        </div>

        <!-- Correo y dominio -->
        <div class="row">
          <div class="col-md-6">
            <fg-input type="email" label="Correo" placeholder="Correo" v-model="device.correo"
              v-validate="modelValidations.correo" name="correo" :error="getError('correo')" />
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Dominio" placeholder="Dominio" v-model="device.dominio"
              v-validate="modelValidations.dominio" name="dominio" :error="getError('dominio')" :disabled="true" />
          </div>
        </div>

        <!-- Institución e identificador -->
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text" label="Instituciones">
              <el-select class="select-primary" placeholder="Seleccione una institución" v-model="device.institutions"
                v-validate="modelValidations.institutions" name="institutions" :error="getError('institutions')">
                <el-option v-for="item in institutions" :key="item.id" :label="item.name" :value="Number(item.id)" />
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Identificador">
              <el-select class="select-primary" placeholder="Seleccione un Identificador" v-model="device.identifier"
                v-validate="modelValidations.identifier" name="identifier" :error="getError('identifier')">
                <el-option v-for="item in identifier" :key="item.id" :label="item.name" :value="Number(item.id)" />
              </el-select>
            </fg-input>
          </div>
        </div>

        <!-- Fecha de vencimiento -->
        <div class="row">
          <div class="col-md-6">
            <fg-input label="Fecha de vencimiento" type="text">
              <el-date-picker :error="getError('finall')" format="yyyy/MM/dd" name="finall"
                placeholder="Fecha de vencimiento" type="date" v-model="device.finall"
                v-validate="modelValidations.finall" />
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Entorno">
              <el-select class="select-primary" placeholder="Seleccione un Entorno" v-model="device.entorno"
                v-validate="modelValidations.entorno" name="entorno" :error="getError('entorno')">
                <el-option :label="'Desarrollo'" :value="'Desarrollo'" />
                <el-option :label="'Pruebas-QA'" :value="'Pruebas-QA'" />
                <el-option :label="'Producción'" :value="'Producción'" />
              </el-select>
            </fg-input>
          </div>
  </div>

          <!-- Módulos y ambiente sólo para SmartConvert -->
<div class="row" v-if="isSmartConvertSelected">
  <div class="col-md-6">
    <fg-input type="text" label="Ambiente">
      <el-select class="select-primary" placeholder="Seleccione un Ambiente" v-model="device.ambiente"
        v-validate="modelValidations.ambiente" name="ambiente" :error="getError('ambiente')">
        <el-option v-for="item in ambientes" :key="item.id" :label="item.name" :value="Number(item.id)" />
      </el-select>
    </fg-input>
  </div>

  <div class="col-md-6">
    <fg-input type="text" label="Módulos">
      <el-select class="select-primary" placeholder="Seleccione uno o varios módulos" v-model="device.modules"
        multiple filterable v-validate="modelValidations.modules" name="modules" :error="getError('modules')">
        <el-option v-for="item in filteredModules" :key="item.id" :label="item.name" :value="Number(item.id)" />
      </el-select>
    </fg-input>
  </div>
</div>
  <div class="row">
    <div class="col-md-6">
            <fg-input type="text" label="HARDWARE ID" placeholder="Ingrese el hardware Id" v-model="device.hardwareid"
              v-validate="modelValidations.hardwareid" name="hardwareid" :error="getError('hardwareid')" />
          </div>
          </div>

        <div class="text-right">
          <button class="btn btn-filmker-pink btn-fill btn-sm">
            Agregar Licencia
          </button>
        </div>
      </form>
    </div>
  </card>
</template>

<script>
import vueElementLoading from 'vue-element-loading'
import swal from 'sweetalert2'
import { DatePicker, Dialog, Option, Select } from 'element-ui'

export default {
  components: {
    vueElementLoading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      institutions: [],
      identifier: [],
      modules: [],
      ambientes: [],
      loading: { text: 'Please Wait', color: '#222', active: false },
      device: {
        company: 'Solution Technology',
        usuario: '',
        correo: '',
        dominio: '',
        institutions: null,
        identifier: null,
        entorno: '',
        hardwareid: "",
        finall: '',
        modules: [],
        ambiente: null
      },
      modelValidations: {
        dominio: { required: true },
        finall: { required: true },
        usuario: { required: true, min: 5 },
        correo: { required: true, email: true },
        institutions: { required: true },
        identifier: { required: true },
        modules: { required: true },
        ambiente: { required: true },
        entorno: { required: true },
        hardwareid: { required: true }
      }
    }
  },
  computed: {
    isSmartConvertSelected() {
      const sel = this.identifier.find(i => Number(i.id) === this.device.identifier)
      return sel && sel.name === 'SmartConvert'
    },
    filteredModules() {

      return this.modules
    },
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    validate() {
      this.$validator.validateAll().then(valid => valid && this.addDevice())
    },
    getUsers() {
      this.loading.active = true
      const headers = { authorization: localStorage.token }
      // Instituciones
      this.axios.get(`conexions.php?datos=1`, { headers })
        .then(r => this.institutions = r.data.message)
        .finally(() => this.loading.active = false)
      // Identificadores
      this.axios.get(`conexions.php?datos=3`, { headers })
        .then(r => this.identifier = r.data.message)
        .finally(() => this.loading.active = false)
      // Módulos
      this.axios.get(`conexions.php?datos=6`, { headers })
        .then(r => this.modules = r.data.message)
        .finally(() => this.loading.active = false)
      // Ambientes
      this.axios.get(`conexions.php?datos=7`, { headers })
        .then(r => this.ambientes = r.data.message)
        .finally(() => this.loading.active = false)


    },

    getError(field) {
      return this.errors.first(field)
    },
    addDevice() {
      this.loading.active = true
      const deviceToSend = { ...this.device }
      deviceToSend.ambiente_id = deviceToSend.ambiente
      delete deviceToSend.ambiente

      this.axios.post(`conexions.php`, deviceToSend, { headers: { authorization: localStorage.token } })
        .then(() => { this.showSwal('success', 'Licencia Creada'); this.clearModel() })
        .catch(err => this.showSwal('error', err.response.data.message))
        .finally(() => this.loading.active = false)
    },
    showSwal(type, message) {
      const icon = type === 'success' ? 'success' : 'warning'
      swal.fire({ title: message, icon })
    },
    clearModel() {
      this.device = { company: 'Solution Technology', usuario: '', correo: '', dominio: '', institutions: null, identifier: null, finall: '', modules: [], ambiente: null,hardwareid : ""}
    },

  },

  watch: {
    'device.institutions'(newInstitutionId) {
      const selectedInstitution = this.institutions.find(
        inst => Number(inst.id) === Number(newInstitutionId)
      );
      if (selectedInstitution && selectedInstitution.domain) {
        this.device.dominio = selectedInstitution.domain;
      } else {
        this.device.dominio = '';
      }
    }
  }
}

</script>

<style>
#edit_form label {
  color: #777 !important;
}
</style>
